@if (show) {
    <mat-progress-bar color="primary" [mode]="mode" [value]="progress"></mat-progress-bar>
}
